















































































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { IRules, sValidation } from '@/components/UI/Form/ValidationModule';
import { ALL_PROJECTS } from '@/queries/Project';
import { ALL_DEPARTMENTS } from '@/queries/Department';
import { PRODUCT_LIST_SEARCH } from '@/queries/Product';
import { UNITS_OF_MEASURE } from '@/queries/UnitOfMeasure';
import {
  GQL_currentUnitProjects,
  GQL_currentUnitProjects_currentUnit_projects,
} from '@/queries/__generated__/currentUnitProjects';
import {
  GQL_currentUnitDepartments,
  GQL_currentUnitDepartments_currentUnit_departments,
} from '@/queries/__generated__/currentUnitDepartments';
import { validateRequired, validateMax, validateType } from '@/components/UI/Form/Validations';
import { ACTIVE_VAT_RATES } from '@/queries/ClientQueries';
import { SmartQuery } from 'vue-apollo-decorator';
import PermissionService from '@/utils/permission-service';
import DeepCopy from '@/decorators/deep-copy';
import { exemptTaxExemptionReasons, zeroTaxExemptionReasons } from '@/app/Product';
import { ALL_PRODUCT_GROUPS } from '@/queries/ProductGroup';
import { GQL_currentUnitProductGroups, GQL_currentUnitProductGroups_currentUnit_productGroups } from '@/queries/__generated__/currentUnitProductGroups';
import { GQL_unitInvoiceSetting, GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting } from '@/queries/__generated__/unitInvoiceSetting';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { UNIT_SEARCH } from '@/queries/Unit';
import { WithUID, WithDestroy, generateUID } from '@/utils/utils';

import dayjs from '@/utils/dayjs';
import Decimal from '@/utils/decimal';
import { GQL_product_product, GQL_product_product_productActivePeriods, GQL_product_product_productPrices } from '@/queries/__generated__/product';
import SPopup from '@/components/UI/Popup/SPopup.vue';
import { sortProductGroups } from '@/app/ProductGroup';
import UnitClosingDatesInfo from '../Unit/UnitClosingDatesInfo.vue';
import { GQL_productListSearch, GQL_productListSearch_products } from '@/queries/__generated__/productListSearch';
import dateRangesOverlap from '@/utils/date-ranges-overlap';
import { GQL_activeNorwegianVatRates, GQL_activeNorwegianVatRates_activeNorwegianVatRates } from '@/queries/__client__/activeNorwegianVatRates';
import { GQL_NorwegianVatSymbolEnum } from '@/queries/global';
import { GQL_unitsOfMeasure_unitsOfMeasure } from '@/queries/__generated__/unitsOfMeasure';
import { ALL_CARS } from '@/queries/Car';
import { GQL_currentUnitCars, GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';

const validateNoOverlappingPricePeriods: sValidation = ({ dataValue, formElements, uid }) => {
  const inForeverLand = '9999-12-31';
  if (!dataValue) return true;
  const date = dayjs.strict(dataValue);

  if (!formElements?.productPrices?.validFrom) return true;
  if (!formElements?.productPrices?.validTo) return true;

  return Object.keys(formElements.productPrices.validFrom)
    .map(uid => {
      return {
        uid: uid,
        startDate: formElements?.productPrices?.validFrom[uid]?.dataValue,
        endDate: formElements?.productPrices?.validTo[uid]?.dataValue || inForeverLand,
      };
    })
    .filter(p => p.uid !== uid) // return true if it's the same period
    .filter(p => !!p.startDate && !!p.endDate) // return true if period doesn't have dates
    .every(p => !date.isBetween(p.startDate, p.endDate, 'day', '[]')); // return true if date doesn't overlap
};

const validateOnlyOneEmptyEndDate: sValidation = ({ formElements, uid }) => {
  const emptyEndDateUid = Object
    .keys(formElements.productPrices.validTo)
    .filter(key => (formElements?.productPrices?.validTo[key]?.dataValue || '').length === 0);

  if (emptyEndDateUid.length <= 1) return true;
  if (uid === undefined) return true;
  return !emptyEndDateUid.includes(uid);
};

@Component({
  components: {
    UnitClosingDatesInfo,
  },
})
export default class ProductForm extends Vue {
  public PermissionService = PermissionService;

  @SmartQuery<ProductForm, GQL_activeNorwegianVatRates, { date: string }>({
    query: ACTIVE_VAT_RATES,
    variables() {
      return {
        date: this.$dayjs().format('YYYY-MM-DD'),
      };
    },
  }) public activeNorwegianVatRates!: GQL_activeNorwegianVatRates_activeNorwegianVatRates[];

  @SmartQuery<ProductForm, GQL_currentUnitCars>({
    query: ALL_CARS,
    update: data => data.currentUnit.cars,
  }) public cars!: GQL_currentUnitCars_currentUnit_cars[];

  @SmartQuery<ProductForm, GQL_currentUnitProjects>({
    query: ALL_PROJECTS,
    update: data => data.currentUnit.projects,
  }) public projects!: GQL_currentUnitProjects_currentUnit_projects[];

  @SmartQuery<ProductForm, GQL_currentUnitDepartments>({
    query: ALL_DEPARTMENTS,
    update: data => data.currentUnit.departments,
  }) public departments!: GQL_currentUnitDepartments_currentUnit_departments[];

  @SmartQuery(UNITS_OF_MEASURE) public unitsOfMeasure!: GQL_unitsOfMeasure_unitsOfMeasure[];

  @SmartQuery<ProductForm, GQL_unitInvoiceSetting>({
    query: UNIT_INVOICE_SETTINGS,
    update: data => data.currentUnit.unitSetting.unitInvoiceSetting,
  }) private unitInvoiceSetting!: GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting;

  @SmartQuery<ProductForm, GQL_currentUnitProductGroups>({
    query: ALL_PRODUCT_GROUPS,
    update: data => sortProductGroups(data.currentUnit.productGroups),
    fetchPolicy: 'no-cache',
  }) public productGroups!: GQL_currentUnitProductGroups_currentUnit_productGroups[];

  private UNIT_SEARCH = UNIT_SEARCH;
  private today = this.$dayjs().format('YYYY-MM-DD');

  @Prop(Object) public data!: GQL_product_product;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public mutation!: any;

  @Prop() private parentPopup!: SPopup

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @DeepCopy('data') private formData!: any;

  private checkingForActiveProductsWithSameNumber = false;
  private productsWithSameNumber: GQL_productListSearch_products[] = [];

  @Watch('formData.number')
  private findExistingProductNumber() {
    this.checkingForActiveProductsWithSameNumber = true;

    this.$apollo.query<GQL_productListSearch>({
      query: PRODUCT_LIST_SEARCH,
      variables: { limit: 100, filters: {exactNumber: this.formData.number} },
      fetchPolicy: 'no-cache',
    }).then(data => {
      this.checkingForActiveProductsWithSameNumber = false;
      this.productsWithSameNumber = data.data.products;
    });
  }

  @Watch('formData.productActivePeriods', { immediate: true })
  private ensureUIDsAreSetForPeriods(): void {
    this
      .formData
      .productActivePeriods
      .filter((period: WithUID<GQL_product_product_productActivePeriods>) => !period.$_UID)
      .forEach((period: WithUID<GQL_product_product_productActivePeriods>) => {
        period.$_UID = generateUID();
      });
  }

  @Watch('formData.productPrices', { immediate: true })
  private ensureUIDsAreSetForPrices(): void {
    this
      .formData
      .productPrices
      .filter((productPrice: WithUID<GQL_product_product_productPrices>) => !productPrice.$_UID)
      .forEach((productPrice: WithUID<GQL_product_product_productPrices>) => {
        productPrice.$_UID = generateUID();
      });
  }

  private validForm = true;
  private validPricesForm = true;

  public carId: string | null = null;
  public projectId: string | null = null;
  public departmentId: string | null = null;
  public productGroupId: string | null = null;
  public supplierUnitId: string | null = null;
  private exemptTaxExemptionReasons = exemptTaxExemptionReasons;
  private zeroTaxExemptionReasons = zeroTaxExemptionReasons;
  private GQL_NorwegianVatSymbolEnum = GQL_NorwegianVatSymbolEnum;

  private selectImagesPopupIsOpen = false;

  private rules: IRules = {
    name: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Product', 'name') }),
      },
      {
        validation: validateMax(255),
        message: i18n => i18n.t('Error.maxLength', { length: 255 }),
      },
    ],
    number: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Product', 'number') }),
      },
      {
        validation: validateMax(20),
        if: ({formElements}) => formElements.number && formElements.number.dataValue,
        message: i18n => i18n.t('Error.maxLength', { length: 20 }),
      },
    ],
    unitOfMeasureCode: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('Product', 'unitOfMeasureCode') }),
      },
    ],
    vatRateSymbol: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('Product', 'vatRateSymbol') }),
    } ],
    taxExemptionReason: [ {
      validation: ({ dataValue, formElements }) => {
        if (!formElements.vatRateSymbol || !formElements.vatRateSymbol.dataValue) return true;

        if (
          formElements.vatRateSymbol.dataValue === GQL_NorwegianVatSymbolEnum.EXEMPT ||
          formElements.vatRateSymbol.dataValue === GQL_NorwegianVatSymbolEnum.ZERO
        ) {
          return (dataValue || '') !== '';
        } else {
          return (dataValue || '') === '';
        }
      },
      message: i18n => i18n.t('Product.taxExemptionReasonMustBeSelected'),
      triggerBy: [ 'vatRateSymbol' ],
    } ],
    checkingForActiveProductsWithSameNumber: [],
    productActivePeriods: {
      activeFrom: [
        {
          validation: validateRequired(),
          message: i18n => i18n.t('Error.required', { field: this.t_attr('ProductActivePeriod', 'activeFrom') }),
        },
        { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
        {
          validation: ({ uid, formElements }) => {
            if (
              // Only validate if activeFrom is set and is a valid date
              !formElements.productActivePeriods ||
              !formElements.productActivePeriods.activeFrom ||
              !formElements.productActivePeriods.activeFrom[uid as string] ||
              !formElements.productActivePeriods.activeFrom[uid as string].dataValue ||
              !this.$dayjs.strict(formElements.productActivePeriods.activeFrom[uid as string].dataValue).isValid() ||

              // Only validate if activeTo is not set or is a valid date
              !formElements.productActivePeriods.activeTo ||
              !formElements.productActivePeriods.activeTo[uid as string] ||
              (
                formElements.productActivePeriods.activeTo[uid as string].dataValue &&
                !this.$dayjs.strict(formElements.productActivePeriods.activeTo[uid as string].dataValue).isValid()
              )
            ) return true;

            const period = {
              activeFrom: formElements.productActivePeriods.activeFrom[uid as string].dataValue,
              activeTo: formElements.productActivePeriods.activeTo[uid as string].dataValue,
              $_UID: uid as string,
            };

            return this.validateNoOverlappingActivePeriods(period);
          },
          message: i18n => i18n.t('Error.dateCannotOverlap'),
          triggerBy: [ 'checkingForActiveProductsWithSameNumber', 'productActivePeriods.activeFrom', 'productActivePeriods.activeTo' ],
        },
      ],
    activeTo: [
      { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
      {
        validation: ({ uid, formElements }) => {
          if (
            !formElements.productActivePeriods ||
            !formElements.productActivePeriods.activeFrom ||
            !formElements.productActivePeriods.activeFrom[uid as string] ||
            !formElements.productActivePeriods.activeFrom[uid as string].dataValue ||
            !this.$dayjs.strict(formElements.productActivePeriods.activeFrom[uid as string].dataValue).isValid() ||

            !formElements.productActivePeriods.activeTo ||
            !formElements.productActivePeriods.activeTo[uid as string] ||
            (
              formElements.productActivePeriods.activeTo[uid as string].dataValue &&
              !this.$dayjs.strict(formElements.productActivePeriods.activeTo[uid as string].dataValue).isValid()
            )
          ) return true;

          const period = {
            activeFrom: formElements.productActivePeriods.activeFrom[uid as string].dataValue,
            activeTo: formElements.productActivePeriods.activeTo[uid as string].dataValue,
            $_UID: uid as string,
          };

          return this.validateNoOverlappingActivePeriods(period);
        },
        message: i18n => i18n.t('Error.dateCannotOverlap'),
        triggerBy: [ 'checkingForActiveProductsWithSameNumber', 'productActivePeriods.activeFrom', 'productActivePeriods.activeTo' ],
      },
    ],
    },
  }
  private rulesPrices: IRules = {
    productPrices: {
      validFrom: [
        { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
        {
          validation: validateRequired(),
          message: i18n => i18n.t('Error.required', { field: this.t_attr('ProductPrice', 'validFrom') }),
        },
        {
          validation: validateNoOverlappingPricePeriods,
          triggerBy: [ 'productPrices.validFrom', 'productPrices.validTo' ],
          message: i18n => i18n.t('Error.dateCannotOverlap'),
        },
      ],
      validTo: [
        { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
        {
          validation: ({ dataValue, formElements, uid }) => {
            if (!formElements?.productPrices?.validFrom[uid as string]?.dataValue || !dataValue) return true;
            return formElements.productPrices.validFrom[uid as string].dataValue <= dataValue;
          },
          message: i18n => i18n.t('Error.mustBeSameOrAfter', {
            beforeField: this.t_attr('ProductPrice', 'validFrom'),
            afterField: this.t_attr('ProductPrice', 'validTo'),
          }),
          triggerBy: [ ({ withSameUID }) => withSameUID('productPrices.validFrom') ],
        },
        {
          validation: validateNoOverlappingPricePeriods,
          triggerBy: [ 'productPrices.validFrom', 'productPrices.validTo' ],
          message: i18n => i18n.t('Error.dateCannotOverlap'),
        },
        {
          validation: validateOnlyOneEmptyEndDate,
          triggerBy: [ 'productPrices.validTo' ],
          message: i18n => i18n.t('Error.required', { field: this.t_attr('ProductPrice', 'validFrom') }),
        },
      ],
      salePrice: [
        { validation: validateType('unumber'), message: i18n => i18n.t('GQL.Type.unumber') },
      ],
      purchasePrice: [
        { validation: validateType('unumber'), message: i18n => i18n.t('GQL.Type.unumber') },
      ],
    },
  };

  private validateNoOverlappingActivePeriods(period: { activeFrom: string; activeTo: string | null; $_UID: string }): boolean {
    if (this.checkingForActiveProductsWithSameNumber) return false;

    const productsBesidesCurrent = this.productsWithSameNumber.filter(p => p.id != this.data.id);
    const savedPeriods = productsBesidesCurrent.flatMap(p => p.productActivePeriods);
    if (savedPeriods.some(p => dateRangesOverlap(period.activeFrom, period.activeTo, p.activeFrom, p.activeTo))) {
      return false;
    }

    const unsavedPeriods = (this.notDeletedPeriods as WithUID<GQL_product_product_productActivePeriods>[])
      .filter(p => p.$_UID != period.$_UID)
      .filter(p => (
        this.$dayjs.strict(p.activeFrom).isValid() &&
        (!p.activeTo || this.$dayjs.strict(p.activeTo).isValid())
      ));
    if (unsavedPeriods.some(p => dateRangesOverlap(period.activeFrom, period.activeTo, p.activeFrom, p.activeTo))) {
      return false;
    }

    return true;
  }

  public created() {
    this.carId = this.data.car ? this.data.car.id : null;
    this.projectId = this.data.project ? this.data.project.id : null;
    this.departmentId = this.data.department ? this.data.department.id : null;
    this.productGroupId = this.data.productGroup ? this.data.productGroup.id : null;
    this.supplierUnitId = this.data.supplierUnit ? this.data.supplierUnit.id : null;
  }

  public formatData(data: GQL_product_product) {
    return {
      ...data,
      productPrices: data.productPrices.map(price => {
        return {
          ...price,
          id: price.id ? price.id : undefined,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          _destroy: price.id ? (price as any)._destroy : undefined,
          $_UID: undefined,
          contributionMargin: undefined,
          contributionMarginPercentage: undefined,
        };
      }),
      carId: this.carId,
      projectId: this.projectId,
      departmentId: this.departmentId,
      productGroupId: this.productGroupId,
      supplierUnitId: this.supplierUnitId,
      productActivePeriods: data.productActivePeriods.map(period => {
        return {
          ...period,
          id: period.id ? period.id : undefined,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          _destroy: period.id ? (period as any)._destroy : undefined,
          $_UID: undefined,
        };
      }),
    };
  }

  private get imageUrls() {
    return (this.formData.images as Array<File | {url: string; _destroy?: boolean}>)
      .filter(image => !('_destroy' in image) || !image._destroy)
      .map(image => {
        if ('url' in image) {
          return image.url;
        } else {
          return URL.createObjectURL(image);
        }
      });
  }

  private addProductPrice() {
    this.formData.productPrices.push({
      id: null,
      validFrom: null,
      validTo: null,
      salePrice: new Decimal(0),
      purchasePrice: new Decimal(0),
      _destroy: false,
    });
  }

    private addProductActivePeriod() {
      this.formData.productActivePeriods.push({
        id: null,
        activeFrom: dayjs().format('YYYY-MM-DD'),
        activeTo: null,
      });
    }

  private removeProductPrice(productPrice: WithUID<GQL_product_product_productPrices>) {
    if ('id' in productPrice && productPrice.id) {
      Vue.set(productPrice, '_destroy', true);
    } else {
      this.formData.productPrices.splice(
        this.formData.productPrices.indexOf(productPrice),
        1,
      );
    }
  }

  private removeProductActivePeriod(productActivePeriod: WithUID<GQL_product_product_productActivePeriods>) {
    if ('id' in productActivePeriod && productActivePeriod.id) {
      Vue.set(productActivePeriod, '_destroy', true);
    } else {
      this.formData.productActivePeriods.splice(
        this.formData.productActivePeriods.indexOf(productActivePeriod),
        1,
      );
    }
  }

  private get notDeletedProductPrices() {
    return this
      .formData
      .productPrices
      .filter((productprice: WithDestroy<GQL_product_product_productPrices>) =>
        !('_destroy' in productprice) ||
        !productprice._destroy,
      );
  }

  private get notDeletedPeriods() {
    return this
      .formData
      .productActivePeriods
      .filter((period: WithDestroy<GQL_product_product_productActivePeriods>)=>
        !('_destroy' in period) ||
        !period._destroy,
      );
  }

  @Emit()
  public mutationDone() {}

  @Watch('formData.vatRateSymbol')
  private vatRateSymbolChanged(): void {
    this.formData.taxExemptionReason = null;
  }
}
